import { Injectable } from '@angular/core';
import { EstimateTypeEnum } from '@enums/EstimateType';
import { Estimate } from '@interfaces/Estimate';
import { EstimateService } from './estimate.service';

@Injectable({
  providedIn: 'root'
})
export class ValidationsService {
  private errors: string[] = [];

  public constructor(private estimateService: EstimateService) {}

  public async validateEstimate(currentEstimate: Estimate, overBudget: boolean, totalBillableFinal: number) {
    this.errors = [];
    switch (currentEstimate.estimateType) {
      case EstimateTypeEnum.Reallocation:
        this.validateOverBudget(overBudget);
        this.validateTotalBillableFinal(totalBillableFinal);
        break;
      case EstimateTypeEnum.AdditionalService:
        this.validateOverBudget(overBudget);
        break;
      default:
    }

    this.validateLaborBillingMethod(currentEstimate);
    await this.validateProblematicSublevels();

    return this.errors;
  }

  private async validateProblematicSublevels() {
    const problematicSublevels = await this.estimateService.getAlreadyDeployedSubLevels();

    const isError =
      problematicSublevels.problematicSubLevel1Codes.length > 0 ||
      Object.keys(problematicSublevels.problematicSubLevel2Codes).length > 0;

    if (isError) {
      this.errors.push('alreadyDeployedSubLevels');
    }
  }

  private validateLaborBillingMethod(currentEstimate: Estimate) {
    if (!currentEstimate.laborBillingMethodCode) {
      const needsLaborBillingMethod = currentEstimate.structures
        .filter(s => s.level2IsUsingLaborBillingMethod)
        .some(s => s.estimateLines.some(el => el.classificationLines.length > 0));

      if (needsLaborBillingMethod) {
        this.errors.push('needsLaborBillingMethod');
      }
    }
  }

  private validateOverBudget(overBudget: boolean) {
    if (overBudget) {
      this.errors.push('overBudget');
    }
  }

  private validateTotalBillableFinal(totalBillableFinal: number) {
    if (totalBillableFinal !== 0.0) {
      const roundedBillableFinal = Math.round((totalBillableFinal + Number.EPSILON) * 100) / 100;

      if (roundedBillableFinal !== 0.0) {
        this.errors.push('totalBillableFinal');
      }
    }
  }
}
